import { Injectable, EventEmitter } from '@angular/core';
import { User, UserManager } from 'oidc-client';
import { Observable, from } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private manager: UserManager = new UserManager(environment.authConfig);

  public loginStatusChanged: EventEmitter<User> = new EventEmitter();

  public userKey = `oidc.user:${environment.authConfig.authority}:${environment.authConfig.client_id}`;

  constructor() {
    this.manager.events.addAccessTokenExpired(() => {
      this.login();
    });
  }
  login() {
    this.manager.removeUser();
    // 跳转到IDM登录页面
    this.manager.signinRedirect();
    // 跳转到login页面this.router.navigate(['/login'], { replaceUrl: true });
  }

  loginCallBack() {
    return new Observable(
      (observer: { next: (arg0: User) => void; complete: () => void }) => {
        from(this.manager.signinRedirectCallback()).subscribe((user: User) => {
          this.loginStatusChanged.emit(user);
          observer.next(user);
          observer.complete();
        });
      }
    );
  }

  tryGetUser() {
    return from(this.manager.getUser());
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.manager.signoutRedirect();//跳转到IDM登出页面
  }

  get type(): string {
    return 'Bearer';
  }

  get token(): string | null {
    const temp = localStorage.getItem(this.userKey);
    if (temp) {
      const user: User = JSON.parse(temp);
      return user.access_token;
    }
    return null;
  }

  get authorizationHeader(): string | null {
    if (this.token) {
      return `${this.type} ${this.token}`;
    }
    return null;
  }
}
